// extracted by mini-css-extract-plugin
export default {"modal":"modal-leVJY","studentProgressReport":"studentProgressReport-IJnDq","mainContainer":"mainContainer-o6EqV"};